import { Baservices, IApiResponse } from '../../services/Basevices'
import { IResBody } from '../../services/Interfaces'

export const turnOffAllNotification = async (): Promise<IApiResponse<IResBody>> => {
  return Baservices.getMethod(`/notification/changs-status-list`)
}
